module.exports = __webpack_public_path__ + "1ec5f2718631c1e352a440a33837843e.MP3";